import { Shield, Clock, Award, Wrench, Sparkles, ThumbsUp } from "lucide-react";

const defaultFeatures = [
  {
    icon: Shield,
    title: "Licensed & Insured",
    description: "Fully licensed contractors with comprehensive insurance coverage for your peace of mind."
  },
  {
    icon: Clock,
    title: "Fast Installation",
    description: "Most projects completed in as little as one day, minimizing disruption to your home."
  },
  {
    icon: Award,
    title: "Lifetime Warranty",
    description: "Factory Install, which means it has to be held to the standard of the factory. We stand behind our work with industry-leading lifetime warranties on materials and labor."
  },
  {
    icon: Wrench,
    title: "Expert Craftsmen",
    description: "Our skilled technicians have years of experience delivering flawless results."
  },
  {
    icon: Sparkles,
    title: "Premium Materials",
    description: "We use only top-quality, durable materials that look beautiful for years."
  },
  {
    icon: ThumbsUp,
    title: "100% Satisfaction",
    description: "Join thousands of satisfied New Mexico homeowners who trust Prime Baths."
  }
];

export const Features = ({ features, title }) => {
  const featureList = features || defaultFeatures;
  const sectionTitle = title || "Why Choose Prime Baths?";
  
  return (
    <section className="py-20 bg-white" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <span className="text-[#1E4C9A] font-semibold text-sm uppercase tracking-wider">
            Why Us
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-3 mb-4 font-['Playfair_Display']" data-testid="features-title">
            {sectionTitle}
          </h2>
          <div className="section-divider mx-auto" />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featureList.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={index}
                className="feature-card bg-[#F9FAFB] p-8 rounded-xl border border-gray-100 animate-slide-up"
                data-testid={`feature-card-${index}`}
              >
                <div className="w-14 h-14 bg-[#1E4C9A]/10 rounded-xl flex items-center justify-center mb-5">
                  <IconComponent className="h-7 w-7 text-[#1E4C9A]" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 font-['Playfair_Display']">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
